// app/javascript/pages/catalog.js

document.addEventListener('DOMContentLoaded', () => {
    const desktopNavElement = document.getElementById('desktopBrandNav');
    const bodyElement = document.body;

    // Enhanced ScrollSpy with better offset calculation
    const getScrollOffset = () => {
        const offsetValue = getComputedStyle(document.documentElement).getPropertyValue('--scroll-margin-offset').trim();
        return parseInt(offsetValue.replace('px', ''), 10) || 100;
    };

    if (desktopNavElement) {
        try {
            const scrollSpyOffset = getScrollOffset();
            const scrollSpy = new bootstrap.ScrollSpy(bodyElement, {
                target: '#desktopBrandNav',
                offset: scrollSpyOffset,
                method: 'position'
            });

            // Smooth scrolling for navigation links  
            document.querySelectorAll('a[href^="#"]').forEach(anchor => {
                anchor.addEventListener('click', function (e) {
                    e.preventDefault();
                    const target = document.querySelector(this.getAttribute('href'));
                    if (target) {
                        const offsetTop = target.getBoundingClientRect().top + window.pageYOffset - (scrollSpyOffset - 20);
                        window.scrollTo({
                            top: offsetTop,
                            behavior: 'smooth'
                        });
                    }
                });
            });

        } catch (e) {
            console.error("Error initializing ScrollSpy:", e);
        }
    }

    // Enhanced brand search functionality
    function setupBrandSearch(searchInput, navLinks) {
        if (!searchInput || !navLinks) return;
        
        searchInput.addEventListener('input', function() {
            const searchTerm = this.value.toLowerCase().trim();
            
            navLinks.forEach(item => {
                const brandName = item.dataset.brand || '';
                const shouldShow = brandName.includes(searchTerm);
                
                item.style.display = shouldShow ? 'block' : 'none';
                
                // Add search highlight effect
                if (shouldShow && searchTerm) {
                    item.classList.add('search-highlight');
                } else {
                    item.classList.remove('search-highlight');
                }
            });

            // Show "no results" message if needed
            const visibleItems = Array.from(navLinks).filter(item => item.style.display !== 'none');
            const container = navLinks[0]?.parentElement;
            let noResultsMessage = container?.querySelector('.no-results-message');
            
            if (visibleItems.length === 0 && searchTerm) {
                if (!noResultsMessage) {
                    noResultsMessage = document.createElement('li');
                    noResultsMessage.className = 'no-results-message text-center py-3 text-muted';
                    noResultsMessage.innerHTML = '<small><i class="fas fa-search me-2"></i>No brands found</small>';
                    container.appendChild(noResultsMessage);
                }
            } else if (noResultsMessage) {
                noResultsMessage.remove();
            }
        });
    }

    // Setup search for both desktop and mobile
    const desktopSearch = document.getElementById('brandSearch');
    const desktopNavLinks = document.querySelectorAll('#brandNavLinks .nav-item');
    setupBrandSearch(desktopSearch, desktopNavLinks);

    const mobileSearch = document.getElementById('mobileBrandSearch');
    const mobileNavLinks = document.querySelectorAll('#mobileBrandNavLinks .nav-item');
    setupBrandSearch(mobileSearch, mobileNavLinks);

    // Auto-close mobile offcanvas when clicking outside
    const mobileOffcanvas = document.getElementById('mobileBrandNav');
    if (mobileOffcanvas) {
        mobileOffcanvas.addEventListener('click', function(e) {
            if (e.target === this) {
                bootstrap.Offcanvas.getInstance(this)?.hide();
            }
        });
    }

    // Add loading states for images
    document.querySelectorAll('.product-image').forEach(img => {
        img.addEventListener('load', function() {
            this.style.opacity = '1';
        });
        
        img.addEventListener('error', function() {
            const container = this.closest('.product-image-container');
            if (container) {
                container.innerHTML = `
                    <div class="placeholder-image error">
                        <i class="fas fa-exclamation-triangle fa-3x"></i>
                        <p class="mb-0">Image Unavailable</p>
                    </div>
                `;
            }
        });
    });

    // Add intersection observer for animation on scroll
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.animation = 'fadeInUp 0.6s ease forwards';
            }
        });
    }, observerOptions);

    document.querySelectorAll('.product-card').forEach(card => {
        card.style.opacity = '0';
        card.style.transform = 'translateY(20px)';
        observer.observe(card);
    });
});

// Add CSS for animations
const style = document.createElement('style');
style.textContent = `
    @keyframes fadeInUp {
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
    
    .search-highlight {
        animation: pulse 1s ease-in-out;
    }
    
    @keyframes pulse {
        0% { transform: scale(1); }
        50% { transform: scale(1.02); }
        100% { transform: scale(1); }
    }
`;
document.head.appendChild(style);
